import React, { useEffect, useState, useContext } from "react";
import {
  Form,
  Select,
  Typography,
  Row,
  Col,
  Button,
  Input,
  DatePicker,
  Modal,
  message,
  Tag,
  Radio,
} from "antd";
import { platformApi } from "../../../../../api";
import { ContextAPI } from "../../../../../ContextAPI";
import LinkQuotationModal from "./LinkQuotationModal";

import moment from "moment";
const { Text } = Typography;
const { confirm } = Modal;
import {
  customerDataJoi,
  advancedCustomerDataJoi,
} from "../../BookingRegisterJoi";
import {
  generateErrorObj,
  defaultToNull,
  formatValue,
} from "../../../../../utils";
import { number, required } from "@hapi/joi";
import { useBranch } from "../../../../../ContextAPI/branch";

const toProperCase = (str) => {
  if (!str) return "";
  return str.toLowerCase().replace(/(^|\s)\S/g, (L) => L.toUpperCase());
};

const CustomerData = ({
  form,
  open,
  validityRef,
  clearRef,
  data,
  editable,
  customerId,
  setCustomerId,
  customerAvailable,
  setCustomerAvailable,
  mode,
  isSales,
  customerIdFromParent,
  phone,
  setCurrentBookingData,
}) => {
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
  // Track whether we've already initialized the form for the current open session.
  // This prevents the useEffect([open, data]) from resetting all fields whenever
  // `data` changes mid-session (e.g., after linking a quotation).
  const hasInitialized = React.useRef(false);
  const [linkQuotationVisibility, setLinkQuotationVisibility] = useState(false);
  const [linkedQuotations, setLinkedQuotations] = useState([]);
  const [linkedQuotationObjects, setLinkedQuotationObjects] = useState([]);
  const [customerQuotations, setCustomerQuotations] = useState([]);
  const [bookingAuthStatus, updateBookingAuthStatus] = useState(false);
  const [createButton, setCreateButton] = useState(false);

  //login cred
  const { loginCredintials } = useContext(ContextAPI);
  const { selectBranch, nearestBranch } = useBranch();
  //current values of customer
  const [presentCustomerValues, SetPresentCustomerValues] = useState(null);
  const [users, setUser] = useState([]);
  //customer updated details
  const [customerDetails, setCustomerDetails] = useState({});
  //phno valid check
  const [validNum, setValidNum] = useState(false);
  //error msg obj
  const [errorObj, setErrorObj] = useState({});
  // select field values Data
  const [employeeBranch, setEmployeeBranch] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [refferedByData, setRefferedByData] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [localityList, setLocalityList] = useState([]);
  const [country, setCountry] = useState([]);
  const [quotations, setQuotations] = useState([]);

  const relation = [
    { key: "Father", title: "Father" },
    { key: "Mother", title: "Mother" },
    { key: "Sister", title: "Sister" },
    { key: "Brother", title: "Brother" },
    { key: "Daughter", title: "Daughter" },
    { key: "Son", title: "Son" },
    { key: "Wife", title: "Wife" },
    { key: "Husband", title: "Husband" },
    { key: "Father-in-law", title: "Father-in-law" },
    { key: "Mother-in-law", title: "Mother-in-law" },
    { key: "Daughter-in-law", title: "Daughter-in-law" },
    { key: "Son-in-law", title: "Son-in-law" },
    { key: "Sister-in-law", title: "Sister-in-law" },
    { key: "Brother-in-law", title: "Brother-in-law" },
  ];
  // select filter
  const filterMethod = (input, option) => {
    const label = Array.isArray(option?.props?.children)
      ? option.props.children.join("")
      : String(option?.props?.children || "");
    return label.toLowerCase().indexOf((input || "").trim().toLowerCase()) >= 0;
  };

  const linkQuotation = (linkQuotations, save = false, resolvedData = []) => {
    try {
      if (save) {
        message.success("Linked the Quotation!");

        let quotationArr = getFieldValue("quotation") || [];
        let tocheck = Array.isArray(linkQuotations)
          ? [...new Set([...quotationArr, ...linkQuotations])]
          : [...quotationArr];

        // Build updated display strings — use resolvedData from modal (always correct)
        let updatedQuotations = [];
        const allKnown = resolvedData && resolvedData.length ? resolvedData : quotations;
        allKnown.forEach((data) => {
          if (tocheck.includes(data.id)) updatedQuotations.push(data.quotationId);
        });

        // Also merge with existing tags that were not replaced
        const existingObjects = linkedQuotationObjects.filter((obj) =>
          tocheck.includes(obj.id) && !allKnown.find((d) => d.id === obj.id)
        );
        existingObjects.forEach((obj) => {
          if (!updatedQuotations.includes(obj.quotationId))
            updatedQuotations.push(obj.quotationId);
        });

        // Accumulate full objects for tag rendering
        setLinkedQuotationObjects((prev) => {
          const prevMap = {};
          prev.forEach((o) => { prevMap[o.id] = o; });
          allKnown.forEach((o) => { if (tocheck.includes(o.id)) prevMap[o.id] = o; });
          return Object.values(prevMap).filter((o) => tocheck.includes(o.id));
        });

        setCustomerQuotations(tocheck);
        form.setFieldsValue({
          quotation: tocheck,
          quotationsAssociated: updatedQuotations.join(", "),
        });
        // ── Sync parent currentBookingData so buildPayload picks up new quotations ──
        if (setCurrentBookingData) {
          const newObjects = [
            ...linkedQuotationObjects.filter((o) => tocheck.includes(o.id)),
            ...allKnown.filter((o) => tocheck.includes(o.id) && !linkedQuotationObjects.find((p) => p.id === o.id)),
          ];
          setCurrentBookingData((prev) => ({
            ...prev,
            quotation: newObjects,
          }));
        }
      }
      setLinkQuotationVisibility(!linkQuotationVisibility);
    } catch (err) {
      message.error(err.message);
    }
  };

  const removeLinkedQuotation = (objectId) => {
    try {
      const rawArr = getFieldValue("quotation") || [];
      // Normalize: form field may hold full objects OR plain ID strings
      const quotationArr = rawArr.map((item) =>
        typeof item === "object" && item !== null ? item.id : item
      );
      const newQuotationIds = quotationArr.filter((id) => id !== objectId);
      const newObjects = linkedQuotationObjects.filter((o) => o.id !== objectId);
      setLinkedQuotationObjects(newObjects);
      setCustomerQuotations(newQuotationIds);
      form.setFieldsValue({
        quotation: newQuotationIds,
        quotationsAssociated: newObjects.map((o) => o.quotationId).join(", "),
      });
      // ── Sync parent currentBookingData so buildPayload picks up removal ──
      if (setCurrentBookingData) {
        setCurrentBookingData((prev) => ({
          ...prev,
          quotation: newObjects,
        }));
      }
    } catch (err) {
      message.error(err.message);
    }
  };

  const getCustomerDetails = (id) => {
    platformApi.get(`/api/customer/${id}`).then((res) => {
      setCustomerDetails(res.data.response.data);
    });
  };
  // customer search
  const dropdownSearch = (search) => {
    if (!data?.customer)
      platformApi
        .post("/api/options/get", {
          module: search.module,
          column: search.column,
          searchString: search.searchString,
          fields: search.fields,
          size: 20,
          page: 1,
        })
        .then((res) => {
          search.setValue(res.data.response);
        });
    else
      platformApi
        .post("/api/customer/get", {
          page: 1,
          size: 20,
          searchString: data?.customer?.contacts?.[0]?.phone,
        })
        .then((res) => {
          search.setValue(res.data.response.data.customer);
        });
  };
  //gets reffered by list
  const getCustomers = (search) => {
    platformApi
      .post("/api/options/get/", {
        module: search.module,
        column: search.column,
        searchString: search.searchString,
        fields: search.fields,
        size: 20,
        page: 1,
        except:
          form.getFieldValue("customer") ||
          (data?.customer && data?.customer.id) ||
          null,
        include:
          form.getFieldValue("refferedBy") ||
          (data?.refferedBy && data?.refferedBy?.id) ||
          null,
      })
      .then((res) => {
        // search.setValue(res.data.response);
        setRefferedByData([...res.data.response]);
      });
  };

  //control state data
  const handleCountryChange = (id) => {
    if (!id) return;
    const countryId = typeof id === "object" ? id.id : id;
    platformApi
      .post("api/csc/states", { id: countryId })
      .then((result) => {
        const { data } = result;
        if (data.code === 200) {
          setState((prev) => {
            const fetchedStates = data.data || [];
            const existingMap = {};
            fetchedStates.forEach((s) => { existingMap[s.id] = s; });
            prev.forEach((s) => { if (s && s.id && !existingMap[s.id]) existingMap[s.id] = s; });
            return Object.values(existingMap);
          });
        }
      })
      .catch((error) => {
        console.error("Error on Customer form : ", error);
        message.error("Unable to fetch state", 2);
      });
  };

  //gets employee branch list
  const getEmployeeBranch = (id) => {
    try {
      if (id) {
        // form.setFieldsValue({
        //   salesExecutive: id,
        // });
        platformApi.get(`/api/user/getUser/${id}`).then((res) => {
          if (res.data.code === 200) {
            const resData = res.data;
            const branches = resData.data.profile.branch || [];

            setEmployeeBranch(branches);

            if (branches.length === 1) {
              const onlyBranchId = branches[0].id;
              form.setFieldsValue({ branch: onlyBranchId });
              getQuotations(onlyBranchId);
              settingBranchBasedManufacturer(onlyBranchId);
            } else {
              const currentBranchId = form.getFieldValue("branch");
              const isValidBranch = branches.some(
                (branch) => branch.id === currentBranchId
              );

              if (!isValidBranch) {
                const defaultBranchId = branches[0]?.id;
                form.setFieldsValue({ branch: defaultBranchId });
                getQuotations(defaultBranchId);
              } else {
                getQuotations(currentBranchId);
              }
            }
          }
        });
      }
    } catch (err) {
      message.error(err.message);
    }
  };

  //setting up branch based manufacturer for next tab
  const settingBranchBasedManufacturer = (id) => {
    employeeBranch.map((eachBranch) => {
      if (eachBranch.id === id) {
        data.branchManufacturer = eachBranch.manufacturer;
      }
    });
  };
  const getQuotations = (branch = null) => {
    platformApi
      .get(`/api/quotation?branch=${branch}&lite=true`)
      .then((result) => {
        const {
          data: {
            code,
            response: { data },
          },
        } = result;
        if (code === 200) {
          setQuotations(data);
        }
      })
      .catch((error) => {
        console.error("Error on Customer form : ", error);
        message.error("Unable to fetch country", 2);
      });
  };

  //control city and district data
  const handleStateChange = (id) => {
    if (!id) return;
    const stateId = typeof id === "object" ? id.id : id;
    platformApi
      .post("api/csc/cities", { id: stateId })
      .then((result) => {
        const { data } = result;
        if (data.code === 200) {
          setCity((prev) => {
            const fetchedCities = data.data || [];
            const existingMap = {};
            fetchedCities.forEach((c) => { existingMap[c.id] = c; });
            prev.forEach((c) => { if (c && c.id && !existingMap[c.id]) existingMap[c.id] = c; });
            return Object.values(existingMap);
          });
        }
      })
      .catch((error) => {
        console.error("Error on Customer form : ", error);
        message.error("Unable to fetch cities", 2);
      });

    platformApi
      .post("api/csc/districts", { id: stateId })
      .then((result) => {
        const { data } = result;
        if (data.code === 200) {
          setDistrictList((prev) => {
            const fetchedDistricts = data.data || [];
            const existingMap = {};
            fetchedDistricts.forEach((d) => { existingMap[d.id] = d; });
            prev.forEach((d) => { if (d && d.id && !existingMap[d.id]) existingMap[d.id] = d; });
            return Object.values(existingMap);
          });
        }
      })
      .catch((error) => {
        console.error("Error on Customer form : ", error);
        message.error("Unable to fetch districts", 2);
      });
  };

  const handleCityChange = (id) => {
    if (!id) return;
    const cityId = typeof id === "object" ? id.id : id;
    platformApi
      .post("api/csc/localities", { id: cityId })
      .then((result) => {
        const { data } = result;
        if (data.code === 200) {
          const list = data.data || [];
          setLocalityList(list);
          const currentLoc = form.getFieldValue("locality");
          if (currentLoc) {
            const matched = list.find(
              (l) => l.id === currentLoc || l.localityName === currentLoc
            );
            if (matched) {
              form.setFieldsValue({ locality: matched.id, pincode: matched.pinCode });
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error on Booking form : ", error);
        message.error("Unable to fetch localities", 2);
      });
  };

  const handleLocalityChange = (val) => {
    const selected = localityList.find((loc) => loc.id === val || loc.localityName === val);
    if (selected) {
      form.setFieldsValue({ pincode: selected.pinCode });
      delete errorObj.pincode;
      setErrorObj({ ...errorObj });
    }
  };

  const getLocalityName = (val) => {
    if (!val) return null;
    const found = localityList.find((l) => l.id === val || l.localityName === val);
    return found ? found.localityName : val;
  };

  useEffect(() => {
    if (nearestBranch && !data?.id) {
      form.setFieldsValue({ branch: nearestBranch.id });
      // also trigger your branch dependent logic
      settingBranchBasedManufacturer(nearestBranch.id);
      getQuotations(nearestBranch.id);
    }
  }, [nearestBranch]);

  useEffect(() => {
    if (phone && editable) {
      form.setFieldsValue({ phone: phone });
      searchCustomer(phone);
    }
  }, [phone])

  // useEffect(() => {
  //   if (!open) return;
  //   if (isSales) {
  //     // Always set form fields from data prop, never fetch or update from API
  //     // Map the snapshot data to form fields
  //     const quotation = (data?.quotation || []).map(
  //       (e) => e.quotationId || e.id
  //     );
  //     setCustomerAvailable(false);
  //     setCustomerId(data?.customerId);
  //     setCustomerDetails({
  //       customerId: data?.customerId,
  //       id: data?.id,
  //       name: data?.customerName,
  //       gender: data?.customerGender,
  //       father: data?.customer?.fatherName,
  //       line1: data?.customer?.address?.line1,
  //       line2: data?.customer?.address?.line2,
  //       line3: data?.customer?.address?.line3,
  //       phone: data?.customerPhone,
  //       locality: data?.customerLocality,
  //       country: data?.customerCountry,
  //       state: data?.customerState ?? data?.customer?.address?.state?.name ?? null,
  //       city: data?.customerCity ?? data?.customer?.address?.district?.name ?? null,
  //       pincode: data?.customerPincode,
  //       email: data?.customerEmail,
  //       dob: data?.customerDob,
  //     });
  //     setCustomerQuotations(data?.quotation || []);
  //     setErrorObj({});
  //     // Fix: Populate users array with executive for Select display
  //     if (data?.executive && data?.executive.id) {
  //       setUser([data.executive]);
  //     }
  //     // Fix: Populate employeeBranch array with branch for Select display
  //     if (data?.branch && data?.branch.id) {
  //       setEmployeeBranch([data.branch]);
  //     }
  //     form.setFieldsValue({
  //       customer: data?.customerName,
  //       customerId: data?.customerId,
  //       fatherName: data?.customer?.fatherName,
  //       phone: data?.customerPhone,
  //       DOB: data?.customerDob ? moment(data?.customerDob) : undefined,
  //       gender: data?.customerGender,
  //       locality: data?.customerLocality,
  //       state: data?.customerState ?? data?.customer?.address?.state?.name ?? null,
  //       country: data?.customerCountry,
  //       city: data?.customerCity ?? data?.customer?.address?.district?.name ?? null,
  //       street: data?.customerAddress,
  //       line1: data?.customer?.address?.line1,
  //       line2: data?.customer?.address?.line2,
  //       line3: data?.customer?.address?.line3,
  //       pincode: data?.customerPincode,
  //       email: data?.customerEmail,
  //       quotationsAssociated: quotation,
  //       quotation: data?.quotation || [],
  //       salesExecutive: data?.executive?.id,
  //       nominee: data?.nomineeName,
  //       nomineeAge: data?.nomineeAge,
  //       relationship: data?.relationship,
  //       branch: data?.branch?.id,
  //       refferedBy: data?.refferedBy?.id,
  //     });
  //     return;
  //   }
  //   // if(!data?.bookingId) return;
  //   if (open && !isSales) {
  //     platformApi
  //       .get("/api/csc/country")
  //       .then((result) => {
  //         const { data } = result;
  //         if (data.code === 200) {
  //           setCountry(data.data);
  //           if (data.data.length === 1) {
  //             form.setFieldsValue({ country: data?.data[0]?.id });
  //             handleCountryChange(data?.data[0]?.id);
  //           }
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error on Customer form:", error);
  //         message.error("Unable to fetch country", 2);
  //       });

  //     getQuotations();
  //   }
  //   // Replace the problematic section with this corrected version:

  //   if (!data?.bookingId && !data?.executive && !isSales) {
  //     platformApi.get("/api/user/currentUser").then((result) => {
  //       let { data } = result;
  //       if (data.code === 200) {
  //         let { response } = data;
  //         if (response.code === 200) {
  //           const currentUser = response.data;
  //           form.setFieldsValue({
  //             salesExecutive: currentUser.id,
  //           });
  //           getEmployeeBranch(currentUser.id);
  //           if (!users.some(user => user.id === currentUser.id)) {
  //             setUser(prevUsers => [...prevUsers, currentUser]);
  //           }
  //         }
  //       }
  //     });
  //     platformApi.get("/api/user/all")
  //       .then((result) => {
  //         let { data } = result;
  //         if (data.code === 200) {
  //           let { response } = data;
  //           if (response.code === 200) {
  //             setUser(response.data);
  //           }
  //         }
  //       })
  //       .catch((error) => {
  //         message.error("Unable to fetch Users", 1);
  //         console.error("Error on Quotations Form : ", error);
  //       });
  //   } else {
  //     const executive = data?.executive;
  //     if (executive && !users.some((user) => user.id === executive.id)) {
  //       setUser(prevUsers => [...prevUsers, executive]);
  //     }
  //     form.setFieldsValue({
  //       salesExecutive: executive?.id,
  //     });
  //     getEmployeeBranch(data?.executive?.id);
  //   }

  //   if (!isSales) {
  //     platformApi
  //       .get("/api/user/all")
  //       .then((result) => {
  //         let { data } = result;
  //         if (data.code === 200) {
  //           let { response } = data;
  //           if (response.code === 200) {
  //             setUser(response.data);
  //           }
  //         }
  //       })
  //       .catch((error) => {
  //         message.error("Unable to fetch Users", 1);
  //         console.error("Error on Quotations Form : ", error);
  //       });
  //     // search format for customer search using ph no
  //     const search = {
  //       module: "customers",
  //       column: "name",
  //       fields: ["contacts{phone}"],
  //       setValue: setCustomerData,
  //     };
  //     const searchReffered = {
  //       module: "customers",
  //       column: "name",
  //       fields: ["contacts{phone}"],
  //       setValue: setRefferedByData,
  //     };

  //     dropdownSearch(search);
  //     getCustomers(searchReffered);
  //   }
  //   if (data?.customerName) {
  //     setCustomerAvailable(false);
  //     updateBookingAuthStatus(
  //       (data?.authentication && data?.authentication?.verifiedAt) || false
  //     );
  //     let branch = data?.branch && data?.branch.id;
  //     setCustomerId(data?.customerId);
  //     let quotation = [];
  //     let quotationIdArr = [];
  //     data?.quotation.map((e) => {
  //       quotation.push(e.quotationId);
  //       quotationIdArr.push(e.id);
  //     });
  //     form.setFieldsValue({
  //       customer: data?.customerName,
  //       customerId: data?.customerId,
  //       fatherName: data?.customer?.fatherName,
  //       phone: data?.customerPhone,
  //       DOB: moment(data?.customer?.dateOfBirth || data?.customerDob),
  //       gender: data?.customerGender,
  //       locality: data?.customer?.address?.locality ?? data?.customerLocality ?? null,
  //       state: data?.customer?.address?.state?.name ?? data?.customerState ?? null,
  //       country: data?.customerCountry,
  //       city: data?.customer?.address?.district?.name ?? data?.customerCity ?? null,
  //       street: data?.customerAddress,
  //       line1: data?.customer?.address
  //         ? data?.customer?.address?.line1
  //         : data?.customerAddress,
  //       line2: data?.customer?.address
  //         ? data?.customer?.address?.line2
  //         : data?.customerLine2,
  //       line3: data?.customer?.address
  //         ? data?.customer?.address?.line3
  //         : data?.customerLine3,
  //       pincode: data?.customer?.address
  //         ? data?.customer?.address?.pincode
  //         : data?.customer?.customerPhone,
  //       email: data?.customer?.email || data?.customerEmail,
  //       quotationsAssociated: quotation,
  //       quotation: data?.quotation,
  //     });

  //     const searchReffered = {
  //       module: "customers",
  //       column: "name",
  //       fields: ["contacts{phone}"],
  //       setValue: setRefferedByData,
  //     };
  //     getCustomers(searchReffered);
  //     // getFieldValue("country") && handleCountryChange(getFieldValue("country"));
  //     // getFieldValue("state") && handleStateChange(getFieldValue("state"));
  //     SetPresentCustomerValues(form.getFieldsValue());
  //     setErrorObj({});

  //     setCustomerDetails({
  //       customerId: data?.customerId,
  //       name: data?.customerName,
  //       gender: data?.customerGender,
  //       father: data?.customer?.fatherName,
  //       id: data?.id,
  //       // address: data?.customerAddress,
  //       line1: data?.customerLine1,
  //       line2: data?.customerLine2,
  //       line3: data?.customerLine3,
  //       phone: data?.customerPhone,
  //       locality: data?.customerLocality,
  //       country: data?.customerCountry,
  //       state: data?.customerState ?? data?.customer?.address?.state?.name ?? null,
  //       city: data?.customerCity ?? data?.customer?.address?.district?.name ?? null,
  //       pincode: data?.customerPincode,
  //       email: data?.customerEmail,
  //       dob: data?.customerDob,
  //     });
  //     setCustomerQuotations(data?.quotation);
  //     settingBranchBasedManufacturer((data?.branch && data?.branch.id) || null);
  //     let isPhnumValid =
  //       data?.customerPhone && data?.customerPhone.length === 10;
  //     setValidNum(isPhnumValid);

  //     const executive = data?.executive;
  //     if (executive && !users.some((user) => user.id === executive.id)) {
  //       setUser((prevUsers) => [...prevUsers, executive]);
  //     }
  //     form.setFieldsValue({
  //       salesExecutive: executive?.id,
  //       nominee: data?.nomineeName,
  //       nomineeAge: data?.nomineeAge,
  //       relationship: data?.relationship,
  //       branch: data?.branch.id,
  //       refferedBy: data?.refferedBy && data?.refferedBy.id,
  //     });
  //     getEmployeeBranch(executive?.id);
  //   } else if (data?.customer && !isSales) {
  //     setCustomerAvailable(true);
  //     updateBookingAuthStatus(
  //       (data.authentication && data.authentication.verifiedAt) || false
  //     );
  //     let branch = data.branch && data.branch.id;
  //     //set up cutomer data in all fields
  //     setCustomerFields(data?.customer?.id, true, branch, false);
  //     //set up cutomer data for this module
  //     setCustomerDetails(data?.customer);
  //     setCustomerQuotations(data.quotation);
  //     settingBranchBasedManufacturer((data.branch && data.branch.id) || null);
  //     let isPhnumValid = data?.customer?.contacts?.[0]?.phone?.length === 10;
  //     setValidNum(isPhnumValid);
  //     form.setFieldsValue({
  //       customer: data?.customer.id,
  //       salesExecutive: data?.executive && data?.executive?.id,
  //       nominee: data?.nomineeName,
  //       nomineeAge: data?.nomineeAge,
  //       relationship: data?.relationship,
  //       branch: data?.branch?.id,
  //       refferedBy: data?.refferedBy && data?.refferedBy?.id,
  //     });
  //     getEmployeeBranch(data?.executive && data?.executive.id);
  //   }
  // }, [open, data]);

  //reset form
  useEffect(() => {
    // Modal closed: reset initialization guard so next open re-initializes
    if (!open) {
      hasInitialized.current = false;
      return;
    }

    // Already initialized for this open session — data changed due to a mid-session
    // update (e.g., quotation linking). Do NOT re-run the full form reset.
    if (hasInitialized.current) return;

    // If the data hasn't loaded yet, don't mark as initialized
    if (isSales && !data?.customerName) {
      return;
    }
    if (!isSales && !data?.customerName && !data?.customer) {
      return;
    }

    // Mark as initialized for this open session
    hasInitialized.current = true;

    if (isSales) {
      // Always set form fields from data prop, never fetch or update from API
      // Map the snapshot data to form fields
      const quotation = (data?.quotation || []).map(
        (e) => e.quotationId || e.id
      );
      const quotationIdArr = (data?.quotation || []).map((e) => e.id || e);
      setCustomerAvailable(false);
      setCustomerId(data?.customerId);
      setCustomerDetails({
        customerId: data?.customerId,
        id: data?.id,
        name: data?.customerName,
        gender: data?.customerGender || data?.customer?.gender || undefined,
        father: data?.customerFatherName ?? data?.customer?.fatherName,
        line1: data?.customer?.address?.line1 ?? data?.customerLine1 ?? data?.customerAddress ?? null,
        line2: data?.customer?.address?.line2 ?? data?.customerLine2 ?? null,
        line3: data?.customer?.address?.line3 ?? data?.customerLine3 ?? null,
        phone: data?.customerPhone,
        locality: data?.customer?.address?.locality ?? data?.customerLocality ?? null,
        country: data?.customerCountry,
        state: data?.customerState ?? data?.customer?.address?.state?.name ?? null,
        city: data?.customerCity ?? data?.customer?.address?.district?.name ?? null,
        pincode: data?.customerPincode ?? data?.customer?.address?.pincode ?? null,
        email: data?.customerEmail,
        dob: data?.customerDob,
        salutation: data?.customerSalutation || data?.customer?.salutation || undefined,
        customerPancard: data?.customerPancard ?? data?.customer?.panCardNo,
        customerAadharCard: data?.customerAadharCard ?? data?.customer?.aadhaarNo,
      });
      setCustomerQuotations(quotationIdArr);
      // Populate tag display for "Quotations Associated" field
      setLinkedQuotationObjects(data?.quotation || []);
      setErrorObj({});
      // Fix: Populate users array with executive for Select display
      if (data?.executive && data?.executive.id) {
        setUser([data.executive]);
      }
      // Fix: Populate employeeBranch array with branch for Select display
      if (data?.branch && data?.branch.id) {
        setEmployeeBranch([data.branch]);
      }

      // Populate referred customer if exists
      const referredCustomer = data?.refferedBy ?? data?.customer?.refferedBy;
      if (referredCustomer && referredCustomer.id) {
        platformApi.get(`/api/customer/${referredCustomer.id}`).then((res) => {
          const resData = res.data.response.data;
          if (resData) {
            setRefferedByData((prev) => {
              const filtered = prev.filter((c) => c.id !== referredCustomer.id);
              return [...filtered, resData];
            });
          }
        }).catch((err) => {
          console.error("Error fetching referred customer details:", err);
        });

        setRefferedByData((prev) => {
          if (!prev.some((c) => c.id === referredCustomer.id)) {
            return [...prev, referredCustomer];
          }
          return prev;
        });
      }

      const searchReffered = {
        module: "customers",
        column: "name",
        fields: ["contacts{phone}"],
        setValue: setRefferedByData,
      };
      getCustomers(searchReffered);

      const stateObj = typeof data?.customerState === "object" ? data?.customerState : (typeof data?.customer?.address?.state === "object" ? data?.customer?.address?.state : null);
      const cityObj = typeof data?.customerCity === "object" ? data?.customerCity : (typeof data?.customer?.address?.city === "object" ? data?.customer?.address?.city : (typeof data?.customer?.address?.City === "object" ? data?.customer?.address?.City : null));
      const districtObj = typeof data?.customerDistrict === "object" ? data?.customerDistrict : (typeof data?.customer?.address?.district === "object" ? data?.customer?.address?.district : (typeof data?.customer?.address?.District === "object" ? data?.customer?.address?.District : null));

      const stateVal = stateObj?.id ?? (typeof data?.customerState === "string" ? data?.customerState : (data?.customer?.address?.state?.id ?? null));
      const cityVal = cityObj?.id ?? (typeof data?.customerCity === "string" ? data?.customerCity : (data?.customer?.address?.city?.id ?? data?.customer?.address?.City?.id ?? null));
      const districtVal = districtObj?.id ?? (typeof data?.customerDistrict === "string" ? data?.customerDistrict : (data?.customer?.address?.district?.id ?? data?.customer?.address?.District?.id ?? null));
      const countryVal = data?.customerCountry?.id ?? data?.customerCountry ?? data?.customer?.address?.country?.id ?? data?.customer?.address?.country;

      if (stateObj && stateObj.id && stateObj.name) {
        setState((prev) => prev.some((s) => s.id === stateObj.id) ? prev : [...prev, { id: stateObj.id, name: stateObj.name }]);
      }
      if (cityObj && cityObj.id && cityObj.name) {
        setCity((prev) => prev.some((c) => c.id === cityObj.id) ? prev : [...prev, { id: cityObj.id, name: cityObj.name }]);
      }
      if (districtObj && districtObj.id && districtObj.name) {
        setDistrictList((prev) => prev.some((d) => d.id === districtObj.id) ? prev : [...prev, { id: districtObj.id, name: districtObj.name }]);
      }

      if (countryVal) {
        handleCountryChange(countryVal);
      }
      if (stateVal) {
        handleStateChange(stateVal);
      }

      form.setFieldsValue({
        customer: data?.customerName,
        customerId: data?.customerId,
        fatherName: data?.customerFatherName ?? data?.customer?.fatherName,
        phone: data?.customerPhone,
        DOB: data?.customerDob ? moment(data?.customerDob) : undefined,
        gender: data?.customerGender || data?.customer?.gender || undefined,
        locality: data?.customer?.address?.locality ?? data?.customerLocality ?? null,
        state: stateVal ?? null,
        country: countryVal ?? null,
        city: cityVal ?? null,
        district: districtVal ?? null,
        street: data?.customerAddress,
        line1: data?.customer?.address?.line1 ?? data?.customerLine1 ?? data?.customerAddress ?? null,
        line2: data?.customer?.address?.line2 ?? data?.customerLine2 ?? null,
        line3: data?.customer?.address?.line3 ?? data?.customerLine3 ?? null,
        pincode: data?.customerPincode ?? data?.customer?.address?.pincode ?? null,
        email: data?.customerEmail,
        quotationsAssociated: quotation,
        quotation: quotationIdArr,
        salesExecutive: data?.executive?.id,
        nominee: data?.nomineeName,
        nomineeAge: data?.nomineeAge,
        relationship: data?.relationship,
        branch: data?.branch?.id,
        fatherSalutation: data?.customerSalutation || data?.customer?.salutation || undefined,
        customerPancard: data?.customerPancard ?? data?.customer?.panCardNo,
        customerAadharCard: data?.customerAadharCard ?? data?.customer?.aadhaarNo,
        refferedBy: referredCustomer?.id,
      });
      return;
    }

    // if(!data?.bookingId) return;
    if (open && !isSales) {
      platformApi
        .get("/api/csc/country")
        .then((result) => {
          const { data } = result;
          if (data.code === 200) {
            setCountry(data.data);
            if (data.data.length === 1) {
              form.setFieldsValue({ country: data?.data[0]?.id });
              handleCountryChange(data?.data[0]?.id);
            }
          }
        })
        .catch((error) => {
          console.error("Error on Customer form:", error);
          message.error("Unable to fetch country", 2);
        });

      // getQuotations();
    }

    // Replace the problematic section with this corrected version:
    if (!data?.bookingId && !data?.executive && !isSales) {
      platformApi.get("/api/user/currentUser").then((result) => {
        let { data } = result;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            const currentUser = response.data;
            form.setFieldsValue({
              salesExecutive: currentUser.id,
            });
            getEmployeeBranch(currentUser.id);
            if (!users.some(user => user.id === currentUser.id)) {
              setUser(prevUsers => [...prevUsers, currentUser]);
            }
          }
        }
      });
      platformApi.get("/api/user/all")
        .then((result) => {
          let { data } = result;
          if (data.code === 200) {
            let { response } = data;
            if (response.code === 200) {
              setUser(response.data);
            }
          }
        })
        .catch((error) => {
          message.error("Unable to fetch Users", 1);
          console.error("Error on Quotations Form : ", error);
        });
    }
    if (!isSales) {
      platformApi
        .get("/api/user/all")
        .then((result) => {
          let { data } = result;
          if (data.code === 200) {
            let { response } = data;
            if (response.code === 200) {
              setUser(response.data);
            }
          }
        })
        .catch((error) => {
          message.error("Unable to fetch Users", 1);
          console.error("Error on Quotations Form : ", error);
        });
      // search format for customer search using ph no
      const search = {
        module: "customers",
        column: "name",
        fields: ["contacts{phone}"],
        setValue: setCustomerData,
      };
      const searchReffered = {
        module: "customers",
        column: "name",
        fields: ["contacts{phone}"],
        setValue: setRefferedByData,
      };

      dropdownSearch(search);
      getCustomers(searchReffered);
    }

    // Check if this is an existing customer with data
    if (data?.customerName) {
      setCustomerAvailable(true);
      updateBookingAuthStatus(
        (data?.authentication && data?.authentication?.verifiedAt) || false
      );
      let branch = data?.branch && data?.branch.id;
      setCustomerId(data?.customerId);
      let quotation = [];
      let quotationIdArr = [];
      // (data?.quotation || []).map((e) => {
      (data?.quotation || []).map((e) => {
        quotation.push(e.quotationId);
        quotationIdArr.push(e.id);
      });
      // Populate tag objects from existing quotation data
      const stateObj = typeof data?.customer?.address?.state === "object" ? data?.customer?.address?.state : (typeof data?.customerState === "object" ? data?.customerState : null);
      const cityObj = typeof data?.customer?.address?.city === "object" ? data?.customer?.address?.city : (typeof data?.customer?.address?.City === "object" ? data?.customer?.address?.City : (typeof data?.customerCity === "object" ? data?.customerCity : null));
      const districtObj = typeof data?.customer?.address?.district === "object" ? data?.customer?.address?.district : (typeof data?.customer?.address?.District === "object" ? data?.customer?.address?.District : (typeof data?.customerDistrict === "object" ? data?.customerDistrict : null));

      const stateVal = stateObj?.id ?? (typeof data?.customerState === "string" ? data?.customerState : (data?.customer?.address?.state?.id ?? null));
      const cityVal = cityObj?.id ?? (typeof data?.customerCity === "string" ? data?.customerCity : (data?.customer?.address?.city?.id ?? data?.customer?.address?.City?.id ?? null));
      const districtVal = districtObj?.id ?? (typeof data?.customerDistrict === "string" ? data?.customerDistrict : (data?.customer?.address?.district?.id ?? data?.customer?.address?.District?.id ?? null));
      const countryVal = data?.customerCountry?.id ?? data?.customerCountry ?? data?.customer?.address?.country?.id ?? data?.customer?.address?.country;

      if (stateObj && stateObj.id && stateObj.name) {
        setState((prev) => prev.some((s) => s.id === stateObj.id) ? prev : [...prev, { id: stateObj.id, name: stateObj.name }]);
      }
      if (cityObj && cityObj.id && cityObj.name) {
        setCity((prev) => prev.some((c) => c.id === cityObj.id) ? prev : [...prev, { id: cityObj.id, name: cityObj.name }]);
      }
      if (districtObj && districtObj.id && districtObj.name) {
        setDistrictList((prev) => prev.some((d) => d.id === districtObj.id) ? prev : [...prev, { id: districtObj.id, name: districtObj.name }]);
      }

      if (countryVal) {
        handleCountryChange(countryVal);
      }
      if (stateVal) {
        handleStateChange(stateVal);
      }

      form.setFieldsValue({
        customer: data?.customerName,
        customerId: data?.customerId,
        fatherName: data?.customer?.fatherName,
        phone: data?.customerPhone,
        DOB: (data?.customer?.dateOfBirth || data?.customerDob)
          ? moment(data?.customer?.dateOfBirth || data?.customerDob)
          : null,
        gender: data?.customerGender || data?.customer?.gender || undefined,
        locality: data?.customer?.address?.locality ?? data?.customerLocality ?? null,
        state: stateVal ?? null,
        country: countryVal ?? null,
        city: cityVal ?? null,
        district: districtVal ?? null,
        street: data?.customerAddress,
        line1: data?.customer?.address
          ? data?.customer?.address?.line1
          : data?.customerAddress,
        line2: data?.customer?.address
          ? data?.customer?.address?.line2
          : data?.customerLine2,
        line3: data?.customer?.address
          ? data?.customer?.address?.line3
          : data?.customerLine3,
        pincode: data?.customer?.address
          ? data?.customer?.address?.pincode
          : data?.customer?.customerPhone,
        email: data?.customer?.email || data?.customerEmail,
        quotationsAssociated: quotation,
        quotation: quotationIdArr,
      });

      const searchReffered = {
        module: "customers",
        column: "name",
        fields: ["contacts{phone}"],
        setValue: setRefferedByData,
      };
      getCustomers(searchReffered);
      // getFieldValue("country") && handleCountryChange(getFieldValue("country"));
      // getFieldValue("state") && handleStateChange(getFieldValue("state"));
      SetPresentCustomerValues(form.getFieldsValue());
      setErrorObj({});

      setCustomerDetails({
        customerId: data?.customerId,
        name: data?.customerName,
        gender: data?.customerGender || data?.customer?.gender || undefined,
        father: data?.customerFatherName ?? data?.customer?.fatherName,
        salutation: data?.customerSalutation || data?.customer?.salutation || undefined,
        id: data?.id,
        // address: data?.customerAddress,
        line1: data?.customerLine1,
        line2: data?.customerLine2,
        line3: data?.customerLine3,
        phone: data?.customerPhone,
        locality: data?.customerLocality,
        country: data?.customerCountry,
        state: data?.customerState ?? data?.customer?.address?.state?.name ?? null,
        city: data?.customerCity ?? data?.customer?.address?.district?.name ?? null,
        pincode: data?.customerPincode,
        email: data?.customerEmail,
        dob: data?.customerDob,
        customerPancard: data?.customerPancard ?? data?.customer?.panCardNo,
        customerAadharCard: data?.customerAadharCard ?? data?.customer?.aadhaarNo,
      });
      setCustomerQuotations(data?.quotation);
      settingBranchBasedManufacturer((data?.branch && data?.branch.id) || null);
      let isPhnumValid =
        data?.customerPhone && data?.customerPhone.length === 10;
      setValidNum(isPhnumValid);

      const executive = data?.executive;
      if (executive && !users.some((user) => user.id === executive.id)) {
        setUser((prevUsers) => [...prevUsers, executive]);
      }
      form.setFieldsValue({
        salesExecutive: executive?.id,
        nominee: data?.nomineeName,
        nomineeAge: data?.nomineeAge,
        relationship: data?.relationship,
        branch: data?.branch.id,
        refferedBy: data?.refferedBy && data?.refferedBy.id,
        fatherName: data?.customerFatherName ?? data?.customer?.fatherName,
        fatherSalutation: data?.customerSalutation || data?.customer?.salutation || undefined,
        customerPancard: data?.customerPancard ?? data?.customer?.panCardNo,
        customerAadharCard: data?.customerAadharCard ?? data?.customer?.aadhaarNo,
      });
      getEmployeeBranch(executive?.id);
    }
    // Check if this is an existing customer with customer object
    else if (data?.customer && !isSales) {
      setCustomerAvailable(true);
      updateBookingAuthStatus(
        (data.authentication && data.authentication.verifiedAt) || false
      );
      let branch = data.branch && data.branch.id;
      //set up cutomer data in all fields
      setCustomerFields(data?.customer?.id, true, branch, false);
      //set up cutomer data for this module
      setCustomerDetails(data?.customer);
      setCustomerQuotations(data.quotation);
      // Populate tag objects from existing quotation data
      setLinkedQuotationObjects(data?.quotation || []);
      settingBranchBasedManufacturer((data.branch && data.branch.id) || null);
      let isPhnumValid = data?.customer?.contacts?.[0]?.phone?.length === 10;
      setValidNum(isPhnumValid);
      form.setFieldsValue({
        customer: data?.customer.id,
        salesExecutive: data?.executive && data?.executive?.id,
        nominee: data?.nomineeName,
        nomineeAge: data?.nomineeAge,
        relationship: data?.relationship,
        branch: data?.branch?.id,
        refferedBy: data?.refferedBy && data?.refferedBy?.id,
      });
      getEmployeeBranch(data?.executive && data?.executive.id);
    }
    // For new customer (no data.customerName and no data.customer)
    else {
      // Reset states for new customer
      setCustomerAvailable(false);
      setCreateButton(true);
      setCustomerDetails({});
      setCustomerData([]);
      SetPresentCustomerValues(null);
      setValidNum(false);
      setErrorObj({});

      // Clear customer name field to make it editable
      form.setFieldsValue({
        customer: "",
      });
    }
  }, [open, data]);

  // Sync quotation states when modal is open and data.quotation updates
  useEffect(() => {
    if (open && data?.quotation) {
      const quotationIdArr = (data.quotation || []).map((e) => e.id || e);
      setLinkedQuotationObjects(data.quotation || []);
      setCustomerQuotations(quotationIdArr);
    }
  }, [open, data?.quotation]);

  useEffect(() => {
    clearRef.current = () => {
      form.resetFields();
      setValidNum(false);
      setCustomerDetails([]);
      setErrorObj({});
      setState([]);
      setCity([]);
      SetPresentCustomerValues(null);
      updateBookingAuthStatus(null);
      // Reset quotation states on modal close/reset
      setLinkedQuotationObjects([]);
      setCustomerQuotations([]);
    };
    validityRef.current = () => {
      return validatePage();
    };
    return () => {
      validityRef.current = null;
      clearRef.current = null;
    };
  });

  const validateOnBlur = () => {
    let customerValidation;
    if (mode == "ConfirmBooking") {
      customerValidation = customerDataJoi(
        defaultToNull(form.getFieldsValue())
      );
    } else {
      customerValidation = advancedCustomerDataJoi(
        defaultToNull(form.getFieldsValue())
      );
    }
    if (customerValidation.error) {
      let generatedError = generateErrorObj(customerValidation, {});
      setErrorObj(generatedError);
    } else {
      setErrorObj({});
    }
  };

  const validatePage = () => {
    let isValid = false;
    if (editable) {
      isValid = true;
      form.validateFields((validationError) => {
        isValid = validationError === null;
        let customerValidation;
        if (mode == "ConfirmBooking") {
          customerValidation = customerDataJoi(
            defaultToNull(form.getFieldsValue())
          );
        } else {
          customerValidation = advancedCustomerDataJoi(
            defaultToNull(form.getFieldsValue())
          );
        }
        if (customerValidation.error) {
          console.log("Error", generateErrorObj(customerValidation, errorObj));
          setErrorObj(generateErrorObj(customerValidation, errorObj));
          isValid = false;
        }
      });
    } else {
      isValid = true;
    }
    if (isValid) {
      let accessoryArray = [];

      if (data?.accessories.length > 0) accessoryArray = data.accessories;
      if (
        !customerDetails?.fatherName ||
        !customerDetails?.address?.locality ||
        !customerDetails?.address?.pincode ||
        !customerDetails?.address?.line1 ||
        !customerDetails?.address?.line2 ||
        !customerDetails?.address?.line3
      ) {
        var stateName = state.find((d) => d.id == form.getFieldValue("state"));
        var countryName = country.find(
          (d) => d.id == form.getFieldValue("country")
        );
        var cityName = city.find((d) => d.id == form.getFieldValue("city"));
        var districtName = districtList.find((d) => d.id == form.getFieldValue("district"));

        var updatedCustomerDetails = {
          ...customerDetails,
          address: {
            state: stateName,
            country: countryName,
            city: cityName,
            district: districtName,
            locality: getLocalityName(form.getFieldValue("locality")),
            pincode: form.getFieldValue("pincode"),
            line1: form.getFieldValue("line1"),
            line2: form.getFieldValue("line2"),
            line3: form.getFieldValue("line3"),
          },
          dateOfBirth: form.getFieldValue("DOB"),
          email: form.getFieldValue("email"),
          fatherName: form.getFieldValue("fatherName"),
          salutation: form.getFieldValue("fatherSalutation"),
        };
        setCustomerDetails(updatedCustomerDetails);
        data.branch = { id: getFieldValue("branch") || null };
        data.customer = customerDetails?.id ? { id: customerDetails.id, ...updatedCustomerDetails } : updatedCustomerDetails;
        data.customerId = customerDetails?.customerId;
        data.customerName = customerDetails?.name;
        data.customerFatherName = data?.customer
          ? updatedCustomerDetails?.fatherName
          : customerDetails?.father;
        data.customerSalutation = data?.customer
          ? updatedCustomerDetails?.salutation
          : customerDetails?.salutation;
        data.customerLine1 = data?.customer
          ? updatedCustomerDetails?.address?.line1
            ? updatedCustomerDetails?.address.line1
            : updatedCustomerDetails?.address?.street
          : customerDetails?.address?.line1;
        data.customerLine2 = data?.customer
          ? updatedCustomerDetails?.address?.line2
          : customerDetails?.address?.line2;
        data.customerLine3 = data?.customer
          ? updatedCustomerDetails?.address?.line3
          : customerDetails?.address?.line3;
        data.customerPhone = data?.customer
          ? (updatedCustomerDetails?.contacts?.[0]?.phone ?? updatedCustomerDetails?.phone)
          : customerDetails?.phone;

        data.customerLocality = data?.customer
          ? updatedCustomerDetails?.address?.locality
          : customerDetails?.locality;
        data.customerCountry = data?.customer
          ? updatedCustomerDetails?.address?.country?.name
          : customerDetails?.country;
        data.customerState = data?.customer
          ? (updatedCustomerDetails?.address?.state?.name ?? updatedCustomerDetails?.state)
          : customerDetails?.state;
        data.customerCity = data?.customer
          ? (updatedCustomerDetails?.address?.district?.name ?? updatedCustomerDetails?.city)
          : customerDetails?.state;
        data.customerPincode = data?.customer
          ? updatedCustomerDetails?.address?.pincode
          : customerDetails?.pincode;
        data.customerEmail = data?.customer
          ? updatedCustomerDetails?.email
          : customerDetails?.email;
        data.customerDob = data?.customer
          ? updatedCustomerDetails?.dateOfBirth
          : customerDetails?.dob;
        data.customerGender = getFieldValue("gender") || (data?.customer
          ? updatedCustomerDetails?.gender
          : customerDetails?.gender) || null;
        data.customerPancard = form.getFieldValue("customerPancard") || null;
        data.customerAadharCard = form.getFieldValue("customerAadharCard") || null;
        data.quotation = linkedQuotationObjects || [];
        data.IDbranch = loginCredintials?.branch?.id;
        data.nomineeName = getFieldValue("nominee");
        data.nomineeAge = getFieldValue("nomineeAge");
        data.relationship = getFieldValue("relationship");
        data.refferedBy = { id: getFieldValue("refferedBy") || null };
        data.accessories = accessoryArray;
        data.executive = { id: getFieldValue("salesExecutive") || null };
        if (data?.customerId && !isSales) {
          platformApi
            .put(`api/customer/${customerIdFromParent || customerDetails?.id}/`, {
              gender: getFieldValue("gender") || null,
              fatherName: getFieldValue("fatherName") || null,
              salutation: getFieldValue("fatherSalutation") || null,
              panCardNo: getFieldValue("customerPancard") || null,
              aadhaarNo: getFieldValue("customerAadharCard") || null,
              dateOfBirth:
                (getFieldValue("DOB") && moment(getFieldValue("DOB")).isValid())
                  ? moment(getFieldValue("DOB")).format("DD-MM-YYYY")
                  : null,
              address: {
                line1: getFieldValue("line1") || null,
                line2: getFieldValue("line2") || null,
                line3: getFieldValue("line3") || null,
                locality: getLocalityName(getFieldValue("locality")) || null,
                country:
                  country.find((c) => c.id === getFieldValue("country")) ||
                  customerDetails?.address?.country,
                state:
                  state.find((s) => s.id === getFieldValue("state")) ||
                  customerDetails?.address?.state,
                city:
                  city.find((ci) => ci.id === getFieldValue("city")) ||
                  customerDetails?.address?.city,
                district:
                  districtList.find((di) => di.id === getFieldValue("district")) ||
                  customerDetails?.address?.district,
                pincode: getFieldValue("pincode") || null,
              },
              email: getFieldValue("email") || null,
              quotation: customerQuotations || [],
              update: "quotation",
            })
            .then((result) => {
              if (result.code === 200) {
                message.success("Customer Details Updated!");
              }
            });
        }
      } else {
        data.branch = { id: getFieldValue("branch") || null };

        if (customerDetails?.id) {
          data.customer = {
            id: customerDetails.id,
            ...customerDetails
          };
        } else {
          data.customer = customerDetails;
        }

        data.customerId = customerDetails?.customerId;
        data.customerName = customerDetails?.name;
        data.customerFatherName = data?.customer
          ? customerDetails?.fatherName
          : customerDetails?.father;
        data.customerSalutation = data?.customer
          ? customerDetails?.salutation
          : customerDetails?.salutation;
        data.customerLine1 = data?.customer
          ? customerDetails?.address?.line1
            ? customerDetails?.address.line1
            : customerDetails?.address?.street
          : customerDetails?.address?.line1;
        data.customerLine2 = data?.customer
          ? customerDetails?.address?.line2
          : customerDetails?.address?.line2;
        data.customerLine3 = data?.customer
          ? customerDetails?.address?.line3
          : customerDetails?.address?.line3;
        data.customerPhone = data?.customer
          ? customerDetails?.contacts?.[0]?.phone
          : customerDetails?.phone;
        data.customerLocality = data?.customer
          ? customerDetails?.address?.locality
          : customerDetails?.locality;
        data.customerCountry = data?.customer
          ? customerDetails?.address?.country?.name
          : customerDetails?.country;
        data.customerState = data?.customer
          ? customerDetails?.address?.state?.name
          : customerDetails?.state;
        data.customerCity = data?.customer
          ? customerDetails?.address?.district?.name
          : customerDetails?.city;
        data.customerPincode = data?.customer
          ? customerDetails?.address?.pincode
          : customerDetails?.pincode;
        data.customerEmail = data?.customer
          ? customerDetails?.email
          : customerDetails?.email;
        data.customerDob = data?.customer
          ? customerDetails?.dateOfBirth
          : customerDetails?.dob;
        data.customerGender = getFieldValue("gender") || (data?.customer
          ? customerDetails?.gender
          : customerDetails?.gender) || null;
        data.customerPancard = form.getFieldValue("customerPancard") || null;
        data.customerAadharCard = form.getFieldValue("customerAadharCard") || null;
        data.quotation = linkedQuotationObjects || [];
        data.IDbranch = loginCredintials?.branch?.id;
        data.nomineeName = getFieldValue("nominee");
        data.nomineeAge = getFieldValue("nomineeAge");
        data.relationship = getFieldValue("relationship");
        data.refferedBy = { id: getFieldValue("refferedBy") || null };
        data.accessories = accessoryArray;
        data.executive = { id: getFieldValue("salesExecutive") || null };
        if ((customerIdFromParent || data?.customerId) && !isSales) {
          platformApi
            .put(`api/customer/${customerIdFromParent || customerDetails?.id}/`, {
              fatherName: getFieldValue("fatherName") || null,
              salutation: getFieldValue("fatherSalutation") || null,
              panCardNo: getFieldValue("customerPancard") || null,
              aadhaarNo: getFieldValue("customerAadharCard") || null,
              dateOfBirth:
                (getFieldValue("DOB") && moment(getFieldValue("DOB")).isValid())
                  ? moment(getFieldValue("DOB")).format("DD-MM-YYYY")
                  : null,
              address: {
                line1: getFieldValue("line1") || null,
                line2: getFieldValue("line2") || null,
                line3: getFieldValue("line3") || null,
                locality: getLocalityName(getFieldValue("locality")) || null,
                country:
                  country.find((c) => c.id === getFieldValue("country")) ||
                  customerDetails?.address?.country,
                state:
                  state.find((s) => s.id === getFieldValue("state")) ||
                  customerDetails?.address?.state,
                city:
                  city.find((ci) => ci.id === getFieldValue("city")) ||
                  customerDetails?.address?.city,
                district:
                  districtList.find((di) => di.id === getFieldValue("district")) ||
                  customerDetails?.address?.district,
                pincode: getFieldValue("pincode") || null,
              },
              email: getFieldValue("email") || null,
              quotation: customerQuotations || [],
              update: "quotation",
            })
            .then((result) => {
              if (result.code === 200) {
                message.success("Customer Details Updated!");
              }
            });
        }
      }
      if (isSales) {
        let branchObj = employeeBranch.find(
          (b) => b.id === getFieldValue("branch")
        );
        if (
          !branchObj &&
          data.branch &&
          data.branch.id === getFieldValue("branch")
        ) {
          branchObj = data.branch;
        }
        data.branch = branchObj || { id: getFieldValue("branch") || null };

        let exec = users.find((u) => u.id === getFieldValue("salesExecutive"));
        if (
          !exec &&
          data.executive &&
          data.executive.id === getFieldValue("salesExecutive")
        ) {
          exec = data.executive;
        }
        data.executive = exec || {
          id: getFieldValue("salesExecutive") || null,
        };

        // FIX: Ensure customer object has proper structure with id
        let customerObj = {
          ...customerDetails,
          address: {
            ...customerDetails?.address,
            line1: getFieldValue("line1"),
            line2: getFieldValue("line2"),
            line3: getFieldValue("line3"),
            locality: getLocalityName(getFieldValue("locality")),
            pincode: getFieldValue("pincode"),
            country:
              country.find((c) => c.id === getFieldValue("country")) ||
              customerDetails?.address?.country,
            state:
              state.find((s) => s.id === getFieldValue("state")) ||
              customerDetails?.address?.state,
            city:
              city.find((ci) => ci.id === getFieldValue("city")) ||
              customerDetails?.address?.city,
            district:
              districtList.find((di) => di.id === getFieldValue("district")) ||
              customerDetails?.address?.district,
          },
          name: getFieldValue("customer"),
          father: getFieldValue("fatherName"),
          phone: getFieldValue("phone"),
          email: getFieldValue("email"),
          dob: getFieldValue("DOB"),
          gender: getFieldValue("gender"),
        };

        // Ensure customer has id if available
        if (customerDetails?.id) {
          customerObj.id = customerDetails.id;
        }

        data.customer = customerObj;
        data.quotation = linkedQuotationObjects || [];
      }
    }
    return isValid;
  };
  const setCustomerIdnew = () => {
    platformApi.post("/api/idGenerate/customer").then((res) => {
      let { data } = res;
      if (data.code === 200) {
        let { response } = data;
        if (response?.data)
          // return response.data
          addData(response.data);
      } else {
        message.error("Couldn't fetch id");
      }
    });
  };

  const addData = (customerId) => {
    const name = getFieldValue("customer");
    const phone = getFieldValue("phone");
    if (phone?.length != 10) return;
    const contacts = [
      {
        id: "",
        phone,
        type: "Primary",
        valid: true,
      },
    ];

    const customer = {
      customerId,
      name: name,
      gender: getFieldValue("gender"),
      customerType: "Non Customer",
      fatherName: getFieldValue("fatherName"),
      salutation: getFieldValue("fatherSalutation"),
      panCardNo: getFieldValue("customerPancard"),
      aadhaarNo: getFieldValue("customerAadharCard"),
      contacts: contacts,
      dateOfBirth: (getFieldValue("DOB") && moment(getFieldValue("DOB")).isValid())
        ? moment(getFieldValue("DOB")).format("DD-MM-YYYY")
        : null,
      address: {
        city: getFieldValue("city"),
        district: getFieldValue("district"),
        state: getFieldValue("state"),
        country: getFieldValue("country"),
        line1: getFieldValue("line1"),
        line2: getFieldValue("line2"),
        line3: getFieldValue("line3"),
        locality: getLocalityName(getFieldValue("locality")),
        pincode: getFieldValue("pincode"),
      },
      refferedBy: getFieldValue("refferedBy"),
      IDbranch: getFieldValue("branch"),
      email: getFieldValue("email"),
    };

    platformApi
      .post("/api/customer", customer)
      .then((result) => {
        const { data } = result;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            setCustomerId(customerId);
            message.success("Customer added successfully", 2);
            setCreateButton(false);
            searchCustomer(phone);
          } else {
            message.error("Unable to add customer", 2);
          }
        } else if (data.code === 500 && data.err.code === 500) {
          message.error("Customer name already exists", 2);
        } else {
          message.error("Unable to add customer", 2);
        }
      })
      .catch((error) => {
        message.error("Unable to add customer", 2);
        console.error("Error on customer : ", error);
      });
  };

  const setCustomerFields = (
    id,
    setPhno = true,
    branchId = null,
    validateFields = false
  ) => {
    platformApi
      .get(`/api/customer/${id}?branch=${branchId}`)
      .then((res) => {
        let { data } = res;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            let responseData = response.data;
            setCustomerId(responseData?.customerId);
            let quotation = [];
            let quotationIdArr = [];
            (responseData?.quotation || []).map((e) => {
              quotation.push(e.quotationId);
              quotationIdArr.push(e.id);
            });
            let vehicles = [];
            (responseData?.purchasedVehicle || []).map((e) => {
              vehicles.push(e.vehicle.modelName);
            });
            const stObj = responseData?.address?.state;
            const ctObj = responseData?.address?.city || responseData?.address?.City;
            const dtObj = responseData?.address?.district || responseData?.address?.District;
            const coObj = responseData?.address?.country || responseData?.address?.Country;

            if (stObj && stObj.id && stObj.name) {
              setState((prev) => prev.some((s) => s.id === stObj.id) ? prev : [...prev, { id: stObj.id, name: stObj.name }]);
            }
            if (ctObj && ctObj.id && ctObj.name) {
              setCity((prev) => prev.some((c) => c.id === ctObj.id) ? prev : [...prev, { id: ctObj.id, name: ctObj.name }]);
            }
            if (dtObj && dtObj.id && dtObj.name) {
              setDistrictList((prev) => prev.some((d) => d.id === dtObj.id) ? prev : [...prev, { id: dtObj.id, name: dtObj.name }]);
            }
            if (coObj && coObj.id && coObj.name) {
              setCountry((prev) => prev.some((c) => c.id === coObj.id) ? prev : [...prev, { id: coObj.id, name: coObj.name }]);
            }

            const stId = stObj?.id ?? (typeof responseData?.address?.state === "string" ? responseData?.address?.state : undefined);
            const ctId = ctObj?.id ?? (typeof responseData?.address?.city === "string" ? responseData?.address?.city : undefined);
            const dtId = dtObj?.id ?? (typeof responseData?.address?.district === "string" ? responseData?.address?.district : undefined);
            const coId = coObj?.id ?? (typeof responseData?.address?.country === "string" ? responseData?.address?.country : undefined);

            if (ctId) {
              handleCityChange(ctId);
            }

            form.setFieldsValue({
              customerId: responseData?.customerId,
              customer: responseData.id,
              gender: responseData.gender || responseData.customerGender || undefined,
              fatherSalutation: responseData.salutation || undefined,
              fatherName: responseData.fatherName,
              DOB: responseData.dateOfBirth
                ? moment(responseData.dateOfBirth)
                : null,
              locality: responseData?.address
                ? responseData?.address.locality
                : null,
              state: stId,
              country: coId,
              city: ctId,
              district: dtId,
              // street: responseData.address ? responseData.address.street : null,
              line1: responseData?.address
                ? responseData?.address.line1
                  ? responseData?.address.line1
                  : responseData?.address.street
                : null,
              line2: responseData?.address ? responseData?.address.line2 : null,
              line3: responseData?.address ? responseData?.address.line3 : null,

              pincode: responseData.address
                ? responseData.address.pincode
                : null,
              email: responseData.email,
              quotationsAssociated: quotation,
              quotation: quotationIdArr,
              customerPancard: responseData.panCardNo || responseData.customerPancard,
              customerAadharCard: responseData.aadhaarNo || responseData.customerAadharCard,
            });
            setCustomerQuotations(quotationIdArr);
            // Populate tag display — use customer API quotations only if not already set from booking data
            setLinkedQuotationObjects((prev) =>
              prev && prev.length > 0 ? prev : (responseData?.quotation || [])
            );

            setPhno &&
              form.setFieldsValue({
                phone:
                  (responseData.contacts[0] &&
                    responseData.contacts[0].phone) ||
                  null,
              });
            const searchReffered = {
              module: "customers",
              column: "name",
              fields: ["contacts{phone}"],
              setValue: setRefferedByData,
            };
            getCustomers(searchReffered);
            if (coId) handleCountryChange(coId);
            if (stId) handleStateChange(stId);
            SetPresentCustomerValues(form.getFieldsValue());
            validateFields && validateOnBlur();
            setErrorObj({});
          }
        } else {
          message.error("Unable to fetch Customer");
        }
      })
      .catch((err) => { });
  };

  // search customer using ph
  const searchCustomer = (number) => {
    platformApi
      .get("api/customer/phone/" + number)
      .then((result) => {
        let { data } = result;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            if (response.data[0]) {
              const customer = response.data[0];
              setCustomerData(response.data);
              if (response.data[0].address == null) {
                response.data[0].address = undefined;
              }
              setCustomerDetails(response.data[0]);
              //sets up customer value
              setCustomerAvailable(true);
              // FIX: hide Create Customer button when an existing customer is found
              setCreateButton(false);
              setCustomerFields(
                response.data[0].id,
                false,
                form.getFieldValue("branch"),
                true
              );

              // Set salesOfficer only if quotations exist
              const formValues = {
                customer: response.data[0].id,
              };
              if (
                response.data[0].quotation &&
                response.data[0].quotation.length > 0 &&
                response.data[0].quotation[0].executive
              ) {
                formValues.salesOfficer =
                  response.data[0].quotation[0].executive.id;
              }
              form.setFieldsValue(formValues);
              if (customer.hasAdvanceBooking) {
                Modal.info({
                  title: "Advanced Booking Found",
                  content: (
                    <div>
                      <p>
                        This customer already has an advanced booking.
                      </p>
                    </div>
                  ),
                  okText: "Continue Anyway",
                  closable: true,
                  maskClosable: true,
                });
              }
            } else {
              message.info("Customer not found. You can create a new customer.");
              setCustomerAvailable(false);
              setCreateButton(true);
              // FIX: clear stale quotation tags from previous customer
              setLinkedQuotationObjects([]);
              setCustomerQuotations([]);
              // Reset all customer related fields
              form.setFieldsValue({
                customer: "",
                gender: undefined,
                fatherName: "",
                line1: "",
                line2: "",
                line3: "",
                locality: "",
                pincode: "",
                city: undefined,
                state: undefined,
                country: undefined,
                email: "",
                DOB: null,
                refferedBy: undefined,
                quotationsAssociated: [],
                quotation: [],
              });
              // Remove the presentCustomerValues that was causing the disable
              SetPresentCustomerValues(null);
              setCustomerId(null);
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error on Booking Form : ", error);
      });
  };

  return (
    <Form style={{ marginTop: "4%", marginBottom: "4%" }}>
      <Row type="flex" justify="space-between">
        <Col span={7}>
          <Form.Item colon={false} label={<Text>Branch</Text>}>
            {getFieldDecorator("branch", {
              rules: [{ required: true, message: "Select Branch" }],
            })(
              <Select
                showSearch
                showAction={["click", "focus"]}
                filterOption={filterMethod}
                onChange={(id) => {
                  settingBranchBasedManufacturer(id);
                }}
                onSelect={(id) => {
                  getQuotations(id);
                }}
                // onBlur={validateOnBlur}
                disabled={!editable || bookingAuthStatus}
                placeholder="Branch"
              >
                {employeeBranch.map((branch) => (
                  <Select.Option key={branch.id}>{branch.name}</Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item
            validateStatus={errorObj && errorObj.phone && errorObj.phone.type}
            help={errorObj && errorObj.phone && errorObj.phone.message}
            colon={false}
            label={<Text>Phone</Text>}
          >
            <Row>
              <Col span={editable && !bookingAuthStatus ? 18 : 24}>
                {getFieldDecorator("phone", {
                  rules: [{ required: true, message: "Select Phone" }],
                })(
                  <Input
                    min="0"
                    addonBefore="+91"
                    onKeyUp={(e) =>
                      form.setFieldsValue({
                        phone: formatValue(e, "onlyNo"),
                      })
                    }
                    maxLength={10}
                    disabled={!editable || bookingAuthStatus}
                    placeholder="Phone"
                    required
                    // onBlur={validateOnBlur}
                    onInput={(event) => {
                      const value = event.target.value;
                      if (value.length === 10) {
                        searchCustomer(value);
                      } else {
                        setCustomerId(null);
                        setCustomerAvailable(false);
                        setCreateButton(false);
                        setCustomerDetails({});
                        setCustomerData([]);
                        // FIX: clear stale quotation tags when mid-typing a new phone number
                        setLinkedQuotationObjects([]);
                        setCustomerQuotations([]);
                        // Reset all customer related fields when phone is changed
                        form.setFieldsValue({
                          customer: "",
                          gender: undefined,
                          fatherName: "",
                          line1: "",
                          line2: "",
                          line3: "",
                          locality: "",
                          pincode: "",
                          city: undefined,
                          state: undefined,
                          country: undefined,
                          email: "",
                          DOB: null,
                          refferedBy: undefined,
                          quotationsAssociated: [],
                          quotation: [],
                        });
                      }
                      if (event.target.checkValidity()) {
                        setValidNum(true);
                      } else {
                        setValidNum(false);
                        let salesExecutive = getFieldValue("salesExecutive");
                        let branch = getFieldValue("branch");
                        form.resetFields();
                        setCustomerId(null);
                        setCustomerAvailable(false);
                        // FIX: clear stale quotation tags when phone becomes invalid
                        setLinkedQuotationObjects([]);
                        setCustomerQuotations([]);
                        form.setFieldsValue({
                          salesExecutive,
                          branch,
                        });
                      }
                    }}
                    onChange={() => customerDetails && setCustomerDetails(null)}
                  // pattern="^\d{10}$"
                  />
                )}
              </Col>
            </Row>
          </Form.Item>
        </Col>

        <Col span={7}>
          <Row type="flex" justify="space-between">
            <Col span={8}>
              <Form.Item
                validateStatus={
                  errorObj && errorObj.fatherSalutation && errorObj.fatherSalutation.type
                }
                help={
                  errorObj && errorObj.fatherSalutation && errorObj.fatherSalutation.message
                }
                label={<Text>Salutation</Text>}
                colon={false}
                required={mode == "ConfirmBooking" ? true : false}
              >
                {getFieldDecorator("fatherSalutation", {
                  rules: [
                    {
                      required: mode == "ConfirmBooking" ? true : false,
                      message: "Select Salutation",
                    },
                  ],
                })(
                  <Select
                    disabled={!editable || bookingAuthStatus}
                    placeholder="Sal."
                    showAction={["click", "focus"]}
                  >
                    <Select.Option value="Mr">Mr</Select.Option>
                    <Select.Option value="Mrs">Mrs</Select.Option>
                    <Select.Option value="Ms">Ms</Select.Option>
                    <Select.Option value="Miss">Miss</Select.Option>
                    <Select.Option value="M/S">M/S</Select.Option>
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col span={15}>
              <Form.Item
                required={true}
                colon={false}
                label={<Text>Customer Name</Text>}
              >
                {!editable || bookingAuthStatus ? (
                  <Input
                    value={customerDetails?.name || data?.customerName || data?.customer?.name || ""}
                    disabled={true}
                    placeholder="Customer Name"
                  />
                ) : customerAvailable ? (
                  getFieldDecorator("customer", {
                    rules: [
                      {
                        required: true,
                        message: "Customer Required!",
                      },
                    ],
                  })(
                    <Select
                      onChange={(id) => {
                        setCustomerFields(
                          id,
                          true,
                          form.getFieldValue("branch"),
                          true
                        ),
                          getCustomerDetails(id);
                      }}
                      filterOption={null}
                      placeholder="Customer Name"
                      onSearch={(e) => {
                        const search = {
                          module: "customers",
                          column: "name",
                          searchString: e,
                          fields: ["contacts{phone}"],
                          searchColumns: ["contacts"],
                          setValue: setCustomerData,
                        };
                        dropdownSearch(search);
                      }}
                    >
                      {customerData.map((data) => (
                        <Select.Option value={data.id} key={data.id}>
                          {data.contacts && data.contacts[0]
                            ? data.contacts[0].phone
                            : "No Phone Updated"}
                          - {data.name}
                        </Select.Option>
                      ))}
                    </Select>
                  )
                ) : (
                  getFieldDecorator("customer", {
                    rules: [
                      {
                        required: true,
                        message: "Customer Required!",
                      },
                    ],
                  })(
                    <Input
                      disabled={!editable || bookingAuthStatus} // Removed the presentCustomerValues condition
                      placeholder="Customer Name"
                      onKeyUp={(e) => {
                        const formattedValue = formatValue(e, "allCaps");
                        form.setFieldsValue({
                          customer: formattedValue,
                        });
                      }}
                      onInput={(event) => {
                        const formattedValue = formatValue(event, "allCaps");

                        // Update provisional customer data
                        setProvisional({
                          ...provisional,
                          name: formattedValue,
                          customer: null,
                        });
                      }}
                      onPressEnter={() => setCustomerIdnew()}
                    />
                  )
                )}
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row type="flex" justify="space-between">
        <Col span={7}>
          <Form.Item
            colon={false}
            label={<Text>Gender</Text>}
            required={mode == "ConfirmBooking" ? true : false}
          >
            {getFieldDecorator("gender", {
              initialValue: (() => {
                const g = data?.customerGender || customerDetails?.gender || data?.customer?.gender;
                if (!g) return undefined;
                const lower = String(g).trim().toLowerCase();
                if (lower === "female") return "Female";
                if (lower === "male") return "Male";
                return g;
              })(),
              rules: [
                {
                  required: mode == "ConfirmBooking" ? true : false,
                  message: "Select Gender",
                },
              ],
            })(
              <Radio.Group disabled={!editable || bookingAuthStatus}>
                <Radio value="Male">Male</Radio>
                <Radio value="Female">Female</Radio>
              </Radio.Group>
            )}
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item
            validateStatus={
              errorObj && errorObj.fatherName && errorObj.fatherName.type
            }
            help={
              errorObj && errorObj.fatherName && errorObj.fatherName.message
            }
            colon={false}
            label={<Text>Father/Husband Name</Text>}
            required={mode == "ConfirmBooking" ? true : false}
          >
            {getFieldDecorator("fatherName", {
              rules: [
                {
                  required: mode == "ConfirmBooking" ? true : false,
                  message: "Enter Father/Husband Name",
                },
              ],
            })(
              <Input
                disabled={!editable || bookingAuthStatus}
                placeholder="Father/Husband Name"
                // onBlur={validateOnBlur}
                onKeyUp={(e) =>
                  form.setFieldsValue({
                    fatherName: toProperCase(e.target.value),
                  })
                }
                pattern="^[A-Z][a-zA-Z.\s]*[a-zA-Z.]+$"
                onInput={(event) => {
                  const formattedValue = toProperCase(event.target.value);
                  form.setFieldsValue({
                    fatherName: formattedValue,
                  });
                  if (!event.target.checkValidity()) {
                    setErrorObj({
                      ...errorObj,
                      fatherName: {
                        type: "error",
                        message: "Enter Valid Name",
                      },
                    });
                  } else {
                    delete errorObj.fatherName;
                    setErrorObj({ ...errorObj });
                  }
                }}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item
            validateStatus={errorObj && errorObj.line1 && errorObj.line1.type}
            help={errorObj.line1 && errorObj.line1.message}
            colon={false}
            required={mode == "ConfirmBooking" ? true : false}
            label={<Text>Address Line 1</Text>}
          >
            {getFieldDecorator("line1", {
              rules: [
                {
                  required: mode == "ConfirmBooking" ? true : false,
                  message: "Enter valid Address Line 1",
                },
              ],
            })(
              <Input
                disabled={!editable || bookingAuthStatus}
                onKeyUp={(e) => {
                  const value = toProperCase(e.target.value);
                  form.setFieldsValue({
                    line1: value,
                  });
                }}
                placeholder="Address Line 1"
                onInput={(event) => {
                  const value = toProperCase(event.target.value);
                  if (value !== event.target.value) {
                    event.target.value = value;
                    form.setFieldsValue({
                      line1: value,
                    });
                  }

                  // No special character validation - always valid
                  delete errorObj.line1;
                  setErrorObj(errorObj);
                }}
              />
            )}
          </Form.Item>
        </Col>
      </Row>

      <Row type="flex" justify="space-between">
        <Col span={7}>
          <Form.Item
            validateStatus={errorObj && errorObj.line2 && errorObj.line2.type}
            help={errorObj.line2 && errorObj.line2.message}
            colon={false}
            required={false}
            label={<Text>Address Line 2</Text>}
          >
            {getFieldDecorator("line2", {
              rules: [
                {
                  required: false,
                  message: "Enter valid Address Line 2",
                },
              ],
            })(
              <Input
                disabled={!editable || bookingAuthStatus}
                onKeyUp={(e) => {
                  const value = toProperCase(e.target.value);
                  form.setFieldsValue({
                    line2: value,
                  });
                }}
                placeholder="Address Line 2"
                onInput={(event) => {
                  const value = toProperCase(event.target.value);
                  if (value !== event.target.value) {
                    event.target.value = value;
                    form.setFieldsValue({
                      line2: value,
                    });
                  }

                  // No special character validation
                  delete errorObj.line2;
                  setErrorObj(errorObj);
                }}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item
            validateStatus={errorObj && errorObj.line3 && errorObj.line3.type}
            help={errorObj.line3 && errorObj.line3.message}
            colon={false}
            required={false}
            label={<Text>Address Line 3</Text>}
          >
            {getFieldDecorator("line3", {
              rules: [
                {
                  required: false,
                  message: "Enter valid Address Line 3",
                },
              ],
            })(
              <Input
                disabled={!editable || bookingAuthStatus}
                onKeyUp={(e) => {
                  const value = toProperCase(e.target.value);
                  form.setFieldsValue({
                    line3: value,
                  });
                }}
                placeholder="Address Line 3"
                onInput={(event) => {
                  const value = toProperCase(event.target.value);
                  if (value !== event.target.value) {
                    event.target.value = value;
                    form.setFieldsValue({
                      line3: value,
                    });
                  }

                  // No special character validation
                  delete errorObj.line3;
                  setErrorObj(errorObj);
                }}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item colon={false} label={<Text>Country</Text>}>
            {getFieldDecorator("country", {
              rules: [
                {
                  required: mode == "ConfirmBooking" ? true : false,
                  message: "Select Country",
                },
              ],
            })(
              <Select
                showAction={["click", "focus"]}
                showSearch
                disabled={!editable || bookingAuthStatus}
                placeholder="Country"
                onChange={handleCountryChange}
                filterOption={filterMethod}
              // onBlur={validateOnBlur}
              >
                {country.map((object) => (
                  <Select.Option value={object.id} key={object.id}>
                    {object.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>

      <Row type="flex" justify="space-between">
        <Col span={7}>
          <Form.Item colon={false} label={<Text>State</Text>}>
            {getFieldDecorator("state", {
              rules: [
                {
                  required: mode == "ConfirmBooking" ? true : false,
                  message: "Select State",
                },
              ],
            })(
              <Select
                showAction={["click", "focus"]}
                showSearch
                disabled={!editable || bookingAuthStatus}
                placeholder="State"
                filterOption={filterMethod}
                onChange={handleStateChange}
              // onBlur={validateOnBlur}
              >
                {state.map((object) => (
                  <Select.Option value={object.id} key={object.id}>
                    {object.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item colon={false} label={<Text>City</Text>}>
            {getFieldDecorator("city", {
              rules: [
                {
                  required: mode == "ConfirmBooking" ? true : false,
                  message: "Select City",
                },
              ],
            })(
              <Select
                showAction={["click", "focus"]}
                showSearch
                disabled={!editable || bookingAuthStatus}
                placeholder="City"
                filterOption={filterMethod}
                onChange={(val) => {
                  handleCityChange(val);
                  form.setFieldsValue({ locality: undefined, pincode: undefined });
                }}
              >
                {city.map((object) => (
                  <Select.Option key={object.id} value={object.id}>
                    {object.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item colon={false} label={<Text>District</Text>}>
            {getFieldDecorator("district", {
              rules: [
                {
                  required: mode == "ConfirmBooking" ? true : false,
                  message: "Select District",
                },
              ],
            })(
              <Select
                showAction={["click", "focus"]}
                showSearch
                disabled={!editable || bookingAuthStatus || districtList.length === 0}
                placeholder="District"
                filterOption={filterMethod}
              >
                {districtList.map((object) => (
                  <Select.Option key={object.id} value={object.id}>
                    {object.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>

      <Row type="flex" justify="space-between">
        <Col span={7}>
          <Form.Item
            colon={false}
            label={<Text>Locality</Text>}
            required={mode == "ConfirmBooking" ? true : false}
          >
            {getFieldDecorator("locality", {
              rules: [
                {
                  required: mode == "ConfirmBooking" ? true : false,
                  message: "Select Locality",
                },
              ],
            })(
              <Select
                showAction={["click", "focus"]}
                showSearch
                disabled={!editable || bookingAuthStatus || localityList.length === 0}
                placeholder="Locality"
                filterOption={filterMethod}
                onChange={handleLocalityChange}
              >
                {localityList.map((object) => (
                  <Select.Option key={object.id} value={object.id}>
                    {object.localityName}{object.pinCode ? ` - ${object.pinCode}` : ""}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item
            colon={false}
            label={<Text>Pincode</Text>}
          >
            {getFieldDecorator("pincode", {
              rules: [
                {
                  required: mode == "ConfirmBooking" ? true : false,
                  message: "Enter pincode",
                },
              ],
            })(
              <Input
                disabled={true}
                placeholder="Pincode"
                maxLength={7}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item
            colon={false}
            label={<Text>Email</Text>}
            validateStatus={errorObj && errorObj.email && errorObj.email.type}
            help={errorObj && errorObj.email && errorObj.email.message}
          >
            {getFieldDecorator("email", {
              rules: [{ required: false, message: "Enter email" }],
            })(
              <Input
                disabled={!editable || bookingAuthStatus}
                onWheel={(event) => event.currentTarget.blur()}
                maxLength={50}
                type="email"
                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                placeholder="Email"
                onKeyUp={(e) => {
                  // Allow only valid email characters as user types
                  const value = e.target.value.replace(/[^a-zA-Z0-9@._%+-]/g, '');
                  form.setFieldsValue({
                    email: value,
                  });
                }}
                onInput={(event) => {
                  // Filter out invalid characters as user types
                  const filteredValue = event.target.value.replace(/[^a-zA-Z0-9@._%+-]/g, '');
                  if (filteredValue !== event.target.value) {
                    event.target.value = filteredValue;
                    form.setFieldsValue({
                      email: filteredValue,
                    });
                  }

                  if (!event.target.checkValidity() && filteredValue) {
                    setErrorObj({
                      ...errorObj,
                      email: {
                        type: "error",
                        message: "Enter Valid Email Address",
                      },
                    });
                  } else {
                    delete errorObj.email;
                    setErrorObj(errorObj);
                  }
                }}
              />
            )}
          </Form.Item>
        </Col>
      </Row>

      <Row type="flex" justify="space-between">
        <Col span={7}>
          <Form.Item colon={false} label={<Text>DOB</Text>}>
            {getFieldDecorator("DOB", {
              rules: [
                {
                  required: mode == "ConfirmBooking" ? true : false,
                  message: "Enter DOB",
                },
              ],
            })(
              <DatePicker
                style={{ width: "100%" }}
                format="DD/MM/YYYY"
                disabled={!editable || bookingAuthStatus}
                placeholder="DD/MM/YYYY"
                disabledDate={(current) => {
                  return current && current >= moment().startOf("day");
                }}
              // onBlur={validateOnBlur}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item
            colon={false}
            label={<Text>PAN Card</Text>}
            required={false}
            validateStatus={
              errorObj &&
              errorObj.customerPancard &&
              errorObj.customerPancard.type
            }
            help={
              errorObj &&
              errorObj.customerPancard &&
              errorObj.customerPancard.message
            }
          >
            {getFieldDecorator("customerPancard", {
              rules: [],
            })(
              <Input
                maxLength={10}
                disabled={!editable || bookingAuthStatus}
                placeholder="PAN Card Number"
                style={{ textTransform: "uppercase" }}
                onChange={(e) => {
                  form.setFieldsValue({
                    customerPancard: e.target.value.toUpperCase(),
                  });
                }}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item
            colon={false}
            label={<Text>Aadhar Card</Text>}
            required={mode == "ConfirmBooking" ? true : false}
            validateStatus={
              errorObj &&
              errorObj.customerAadharCard &&
              errorObj.customerAadharCard.type
            }
            help={
              errorObj &&
              errorObj.customerAadharCard &&
              errorObj.customerAadharCard.message
            }
          >
            {getFieldDecorator("customerAadharCard", {
              rules: [
                {
                  required: mode == "ConfirmBooking" ? true : false,
                  message: "Enter Aadhar Card Number",
                },
              ],
            })(
              <Input
                disabled={!editable || bookingAuthStatus}
                placeholder="Aadhar Card Number"
                maxLength={12}
                onKeyUp={(e) => {
                  form.setFieldsValue({
                    customerAadharCard: formatValue(e, "onlyNo"),
                  });
                }}
              />
            )}
          </Form.Item>
        </Col>
      </Row>

      <Row type="flex" justify="space-between">
        <Col span={7}>
          <Form.Item
            validateStatus={
              errorObj && errorObj.nominee && errorObj.nominee.type
            }
            help={errorObj && errorObj.nominee && errorObj.nominee.message}
            colon={false}
            // onBlur={validateOnBlur}
            label={<Text>Nominee Details</Text>}
            required={mode == "ConfirmBooking" ? true : false}
          >
            {getFieldDecorator("nominee", {
              rules: [
                {
                  required: mode == "ConfirmBooking" ? true : false,
                  message: "Enter Nominee Name",
                },
              ],
            })(
              <Input
                disabled={
                  !editable ||
                  //  ||
                  // (presentCustomerValues && presentCustomerValues["nominee"])
                  bookingAuthStatus
                }
                placeholder="Nominee Name"
                onKeyUp={(e) =>
                  form.setFieldsValue({
                    nominee: formatValue(e, "allCaps"),
                  })
                }
                pattern="^[A-Z][a-zA-Z.\s]*[a-zA-Z.]+$"
                onInput={(event) => {
                  if (!event.target.checkValidity()) {
                    setErrorObj({
                      ...errorObj,
                      nominee: {
                        type: "error",
                        message: "Enter Valid Nominee Name",
                      },
                    });
                  } else {
                    delete errorObj.nominee;
                    setErrorObj(errorObj);
                  }
                }}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item
            validateStatus={
              errorObj && errorObj.nomineeAge && errorObj.nomineeAge.type
            }
            help={errorObj && errorObj.nomineeAge && errorObj.nomineeAge}
            colon={false}
            label={<Text>Age</Text>}
          // onBlur={validateOnBlur}
          // required={true}
          >
            {getFieldDecorator("nomineeAge", {
              rules: [
                {
                  required: mode == "ConfirmBooking" ? true : false,
                  message: "Enter Nominee Age",
                },
              ],
            })(
              <Input
                disabled={
                  !editable ||
                  // ||
                  // (presentCustomerValues && presentCustomerValues["nomineeAge"])
                  bookingAuthStatus
                }
                type="text"
                inputMode="numeric"
                maxLength={2}
                onKeyUp={(e) => {
                  // Allow only numbers as user types
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  form.setFieldsValue({
                    nomineeAge: value,
                  });
                }}
                onInput={(event) => {
                  // Filter out non-numeric characters as user types
                  const numericValue = event.target.value.replace(/[^0-9]/g, '');
                  if (numericValue !== event.target.value) {
                    event.target.value = numericValue;
                    form.setFieldsValue({
                      nomineeAge: numericValue,
                    });
                  }

                  // Validate age range (optional)
                  const age = parseInt(numericValue, 10);
                  if (numericValue && (isNaN(age) || age < 1 || age > 120)) {
                    setErrorObj({
                      ...errorObj,
                      nomineeAge: {
                        type: "error",
                        message: "Enter Valid Age (1-120)",
                      },
                    });
                  } else {
                    delete errorObj.nomineeAge;
                    setErrorObj(errorObj);
                  }
                }}
                placeholder="Age"
              />
            )}
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item colon={false} label={<Text>Relationship</Text>}>
            {getFieldDecorator("relationship", {
              rules: [
                {
                  required: mode == "ConfirmBooking" ? true : false,
                  message: "Select Relationship",
                },
              ],
            })(
              <Select
                showAction={["click", "focus"]}
                showSearch
                placeholder="Relationship"
                filterOption={filterMethod}
                // onBlur={validateOnBlur}
                disabled={
                  !editable ||
                  //  ||
                  // (presentCustomerValues &&
                  //   presentCustomerValues["relationship"])
                  bookingAuthStatus
                }
              >
                {relation.map((data) => (
                  <Select.Option key={data.key}>{data.title}</Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>

      <Row type="flex" justify="space-between">
        <Col span={7}>
          <Form.Item colon={false} label={<Text>Quotations Associated</Text>}>
            <Row>
              <Col span={24}>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", minHeight: "32px", padding: "4px 8px", border: "1px solid #d9d9d9", borderRadius: "4px", background: "#fafafa" }}>
                  {linkedQuotationObjects.length > 0 ? (
                    linkedQuotationObjects.map((obj) => (
                      <Tag
                        key={obj.id}
                        closable={editable && customerAvailable}
                        onClose={() => removeLinkedQuotation(obj.id)}
                        style={{ margin: 0, color: "#000000" }}
                      >
                        {obj.quotationId}
                      </Tag>
                    ))
                  ) : (
                    <span style={{ color: "#bfbfbf", fontSize: "14px" }}>No quotations linked</span>
                  )}
                </div>
              </Col>
            </Row>
            {editable && customerAvailable && (
              <Row style={{ marginTop: 4 }}>
                <Col span={24}>
                  <Button type="link" style={{ padding: 0 }} onClick={() => linkQuotation()}>
                    + Link Quotation
                  </Button>
                </Col>
              </Row>
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator("quotation")(<Input type="hidden" />)}
          </Form.Item>
        </Col>
        {
          <LinkQuotationModal
            customerId={customerId || data?.customer?.id}
            existQuotations={data?.quotation}
            form={form}
            handleSave={linkQuotation}
            visibility={linkQuotationVisibility}
          />
        }
        <Col span={7}>
          <Form.Item label="Referred By" colon={false}>
            {getFieldDecorator("refferedBy", {
              rules: [{ required: false, message: "Select Refered By" }],
            })(
              <Select
                showAction={["click", "focus"]}
                showSearch
                placeholder="Referred By"
                disabled={!editable || !customerAvailable}
                filterOption={null}
                // onBlur={validateOnBlur}
                onSearch={(e) => {
                  const search = {
                    module: "customers",
                    column: isNaN(e) ? "name" : "phone",
                    searchString: e,
                    fields: ["contacts{phone}"],
                    searchColumns: ["contacts"],
                    setValue: setRefferedByData,
                  };
                  getCustomers(search);
                }}
              >
                {refferedByData.map((data) => (
                  <Select.Option value={data.id} key={data.id}>
                    {data.contacts && data.contacts[0]
                      ? data.contacts[0].phone
                      : "No Phone Updated"}
                    - {data.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>

        <Col span={7}>
          <Form.Item colon={false} label={<Text>Sales Officer</Text>}>
            {getFieldDecorator("salesExecutive", {
              rules: [{ required: true, message: "Select Sales Executive" }],
            })(
              <Select
                showAction={["click", "focus"]}
                showSearch
                filterOption={filterMethod}
                disabled={!editable || bookingAuthStatus}
                placeholder="Sales Executive"
                // onBlur={validateOnBlur}
                onChange={(id) => {
                  getEmployeeBranch(id);
                }}
              >
                {users.map((user) => (
                  <Select.Option key={user.id} value={user.id}>
                    {user?.profile?.employeeName}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>

      {createButton && (
        <Row type="flex" justify="space-between">
          <Button onClick={() => setCustomerIdnew()}>
            create customer
          </Button>
        </Row>
      )}
    </Form>
  );
};

const WrappedCustomerData = Form.create({ destroyOnUnmount: false })(
  CustomerData
);

export default WrappedCustomerData;